var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-integral-goods-form',{staticClass:"pt-integral-goods-form__page",attrs:{"isEdit":_vm.is_edit,"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }